import React, { useEffect, useState, useMemo } from 'react'; // Added useMemo
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './KatalogInstrumen.css'; // Import the CSS file

const KatalogInstrumen = () => {
  const [instrumenList, setInstrumenList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [selectedImage, setSelectedImage] = useState(null); // State for image popup
  const navigate = useNavigate(); // Hook for navigation

  // Fetch instruments
  const fetchInstrumen = async () => {
    setLoading(true);
    setError('');
    try {
      const instrumenRef = collection(db, 'instrumen');
      const q = query(instrumenRef, orderBy('nama')); // Order by name
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
      setInstrumenList(data);
    } catch (err) {
      console.error("Error fetching instruments:", err);
      setError('Gagal memuat data instrumen.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstrumen();
  }, []);

  // Filtered list based on search term
  const filteredInstrumenList = useMemo(() => {
    if (!searchTerm) {
      return instrumenList;
    }
    return instrumenList.filter(instrumen =>
      instrumen.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (instrumen.kode && instrumen.kode.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [instrumenList, searchTerm]);

  // Handlers for navigation buttons
  const handleAjukanPeminjaman = (instrumen) => {
    // Use the new nested path under /dashboard
    navigate('/dashboard/form-peminjaman-alat', {
      state: { alatId: instrumen.id, namaAlat: instrumen.nama, type: 'instrumen' }
    });
  };

  const handleLihatJadwal = (instrumen) => {
    // Use the new nested path under /dashboard
    navigate('/dashboard/jadwal-penggunaan', {
       state: { alatId: instrumen.id, namaAlat: instrumen.nama, type: 'instrumen' }
     });
  };

  // Handle SOP button click (similar to other components)
  const handleBacaSOP = (item) => {
    if (!item) return;

    // Prefer URL if available - Opens in new tab
    if (item.sopUrl) {
      window.open(item.sopUrl, '_blank', 'noopener,noreferrer');
    }
    // Fallback to Base64 - Opens in new tab (browser handles PDF rendering)
    else if (item.sopBase64) {
      // Check if it's a PDF Base64 string
      if (item.sopBase64.startsWith('data:application/pdf;base64,')) {
        const pdfWindow = window.open("");
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='" +
          item.sopBase64 +
          "'></iframe>"
        );
      } else {
        // For non-PDF Base64 (like DOCX), trigger download as fallback
        const link = document.createElement('a');
        link.href = item.sopBase64;
        link.download = item.sopFileName || 'SOP_File'; // Use filename or default
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      // Handle case where neither is available, maybe show an alert
      alert('File SOP tidak tersedia.');
    }
  };

  // Handler for image click
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  // Handler to close image popup
  const handleCloseImage = () => {
    setSelectedImage(null);
  };

  return (
    <div className="katalog-instrumen-container">
      <h2>Katalog Instrumen</h2>

      {error && <div className="error-message">{error}</div>}

      {/* Search Input */}
      <div className="search-container" style={{ marginBottom: '20px', maxWidth: '400px' }}>
        <input
          type="text"
          placeholder="Cari instrumen berdasarkan nama atau kode..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input" // Add a class for specific styling if needed
          style={{ width: '100%', padding: '8px 10px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>

      {loading ? (
        <div className="loading-message">Memuat data instrumen...</div>
      ) : (
        <div className="katalog-instrumen-table-container">
          <table className="katalog-instrumen-table">
            <thead>
              <tr>
                <th>Nama Instrumen</th>
                <th>Kode</th>
                <th>Spesifikasi</th>
                <th>Lokasi</th>
                <th>Gambar</th>
                <th>SOP</th>
                <th>Aksi</th> {/* Added Actions Column */}
              </tr>
            </thead>
            <tbody>
              {filteredInstrumenList.map((instrumen) => (
                <tr key={instrumen.id}>
                  <td>{instrumen.nama || 'N/A'}</td>
                  <td>{instrumen.kode || 'N/A'}</td>
                  <td>{instrumen.spesifikasi || 'N/A'}</td>
                  <td>{instrumen.lokasi || 'N/A'}</td>
                  <td>
                    {instrumen.gambarBase64 ? (
                      <img 
                        src={instrumen.gambarBase64} 
                        alt={instrumen.nama} 
                        className="table-image" 
                        onClick={() => handleImageClick(instrumen.gambarBase64)}
                        style={{ cursor: 'pointer' }}
                      />
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td>
                    {/* Replace text with a button */}
                    {(instrumen.sopBase64 || instrumen.sopUrl) ? (
                      <button
                        onClick={() => handleBacaSOP(instrumen)}
                        className="btn btn-sop" // Use consistent class
                        style={{
                          padding: '5px 25px',
                          fontSize: '12px',
                          backgroundColor: '#ffc107',
                          color: '#212529',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          marginRight: '5px',
                          display: 'flex',          // Tambah ini
                          alignItems: 'center',     // Vertikal center
                          justifyContent: 'center'  // Horizontal center
                        }}
                        
                        // disabled={loading} // Loading state not typically needed here unless SOP fetch is slow
                      >
                        Baca SOP
                      </button>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  {/* Action Buttons */}
                  <td className="action-buttons" style={{ whiteSpace: 'nowrap' }}>
                     <button
                       onClick={() => handleAjukanPeminjaman(instrumen)}
                       className="btn btn-pinjam" // Add specific classes if needed
                       style={{ marginRight: '5px', padding: '5px 10px', fontSize: '12px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                     >
                       Pinjam
                     </button>
                     <button
                       onClick={() => handleLihatJadwal(instrumen)}
                       className="btn btn-jadwal" // Add specific classes if needed
                       style={{ padding: '5px 10px', fontSize: '12px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                     >
                       Jadwal
                     </button>
                  </td>
                </tr>
              ))}
              {filteredInstrumenList.length === 0 && !loading && (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center' }}> {/* Updated colspan */}
                    {searchTerm ? 'Tidak ada instrumen yang cocok dengan pencarian.' : 'Tidak ada data instrumen yang tersedia.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Image Popup Modal */}
      {selectedImage && (
        <div 
          className="image-popup-overlay" 
          onClick={handleCloseImage}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
        >
          <div 
            className="image-popup-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              backgroundColor: 'white',
              padding: '10px',
              borderRadius: '5px'
            }}
          >
            <button 
              onClick={handleCloseImage}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              &times;
            </button>
            <img 
              src={selectedImage} 
              alt="Enlarged view" 
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                display: 'block'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default KatalogInstrumen;
